import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import langMsg from '@blade/common/pages/result-details/lang/index';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import { fromPage } from '@blade/common/interfaces/result-details';
import { getTaskTargetStr } from '@blade/common/pages/result-details/common/util';
import DetailsRightBottom from '@blade/common/pages/result-details/components/details-right-bottom.vue';
import DetailsType from '@blade/common/pages/result-details/components/details-type.vue';
import DetailsThreshold from '@blade/common/pages/result-details/components/details-threshold.vue';
import detailsPortrait from '@blade/common/pages/alert-details/components/details-portrait.vue';
import colors from '@/styles/color.scss';
let Details = class Details extends Vue {
    sourceImage;
    details;
    detailsIndex;
    showPath;
    maxNum;
    filterImgLv;
    detailsType;
    detailsRoute;
    activeNameTab;
    isDetailsRightBottom;
    detailsShowContentList;
    isRouteBtn;
    onDetailsIndex() { }
    layerVal = false;
    showAllFeature = false;
    showTypeTime = false; // 人脸\人体--展示
    showSimilarity = false; // 相似度--人脸\人体--以图搜图--展示
    isCrowd = false; // 是否是人群事件
    featuresList = [];
    borderColor = colors.borderItemHover;
    getMatchingRate(val) {
        return (val * 100).toFixed(2) + '%';
    }
    get getAssociationFeature() {
        let data = { isShow: false };
        if (this.activeNameTab === 'BODY&FACE' || this.activeNameTab === 'FACE&BODY') {
            let data = {
                captureUrl: this.details?.associationFeatureVO?.captureUrl,
                isShow: true,
            };
            return data;
        }
        return (data.isShow = false);
    }
    get captureUrl() {
        const type = getTaskTargetStr('incidentType', 'type', this.detailsType);
        if (type === 'Face' && this.detailsRoute === fromPage.EVENT_PAGE) {
            if (this.details.incidentRecordVO.incidentType === 'FACE_PEDESTRIAN') {
                return this.details?.incidentRecordVO?.pedestrianAnnotation?.portraitCaptureImage;
            }
            return this.details?.incidentRecordVO?.faceAnnotation?.portraitCaptureImage;
        }
        else {
            if (this.details?.captureUrl) {
                return this.details?.captureUrl;
            }
            if (this.details?.captureImage) {
                return this.details?.captureImage;
            }
        }
    }
    get showFeaturesList() {
        if (this.showAllFeature)
            return this.featuresList;
        return this.featuresList.slice(0, 10);
    }
    get getIncidentType() {
        return this.detailsType || '';
    }
    get showDetailsRightBottom() {
        return (this.isDetailsRightBottom &&
            this.detailsRoute !== fromPage.FILECLUSTER_PAGE &&
            this.detailsRoute !== fromPage.TEXT &&
            this.detailsType !== 'OBJECT_EVERYTHING' &&
            this.detailsType !== 'OBJECT_ALGO');
    }
    get getIncidentRecordVO() {
        return this.details?.incidentRecordVO || '';
    }
    onDetails() {
        this.featuresList = [];
        this.details.features?.forEach((item) => {
            this.featuresList.push(`${item.key}/${item.value}`);
        });
    }
    mounted() {
        this.featuresList = [];
        this.details.features?.forEach((item) => {
            this.featuresList.push(`${item.key}/${item.value}`);
        });
    }
    getShowContent(val) {
        let flag = false;
        if (this.detailsShowContentList.includes(val)) {
            flag = true;
        }
        return flag;
    }
    onFullScreen(type) {
        this.$emit('on-full-screen', type);
    }
    getDisabled() {
        return false;
    }
    getDeviceName(data) {
        if (data.groupDeviceName && data.groupDeviceName !== 'unknown') {
            return data.groupDeviceName;
        }
        if (data.deviceGroupPath && data.deviceGroupPath !== 'unknown') {
            return data.deviceGroupPath;
        }
        if (data.deviceName && data.deviceName !== 'unknown') {
            return data.deviceName;
        }
        return '--';
    }
    closeDetails() {
        this.$emit('close-details');
    }
    addRoute(checkRoute, flag, index) {
        this.$emit('add-route', checkRoute, flag, index);
    }
    deleteRoute(routeData, flag, index) {
        this.$emit('deleted-route', routeData, flag, index);
    }
};
__decorate([
    Prop()
], Details.prototype, "sourceImage", void 0);
__decorate([
    Prop()
], Details.prototype, "details", void 0);
__decorate([
    Prop()
], Details.prototype, "detailsIndex", void 0);
__decorate([
    Prop()
], Details.prototype, "showPath", void 0);
__decorate([
    Prop()
], Details.prototype, "maxNum", void 0);
__decorate([
    Prop()
], Details.prototype, "filterImgLv", void 0);
__decorate([
    Prop()
], Details.prototype, "detailsType", void 0);
__decorate([
    Prop()
], Details.prototype, "detailsRoute", void 0);
__decorate([
    Prop()
], Details.prototype, "activeNameTab", void 0);
__decorate([
    Prop()
], Details.prototype, "isDetailsRightBottom", void 0);
__decorate([
    Prop()
], Details.prototype, "detailsShowContentList", void 0);
__decorate([
    Prop({ default: true })
], Details.prototype, "isRouteBtn", void 0);
__decorate([
    Watch('detailsIndex')
], Details.prototype, "onDetailsIndex", null);
__decorate([
    Watch('details')
], Details.prototype, "onDetails", null);
Details = __decorate([
    Component({
        name: 'Toolbar',
        components: { BlurPicture, DetailsRightBottom, DetailsType, DetailsThreshold, detailsPortrait },
        i18n: {
            sharedMessages: langMsg,
        },
    })
], Details);
export default Details;
